import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { EditIcon } from '@chakra-ui/icons'
import { Box, HStack, IconButton, Stack, Text, VStack } from '@chakra-ui/react'
import { useDisplayModal } from 'context'
import { ShareVehicleContactType, useShareVehicle } from 'context/ShareVehicle'
import { VehicleType } from 'context/Vehicles'
import { primaryColor } from 'theme/foundations/primaryColor'

import { CardBody } from 'components/CustomCard'
import { CustomModal } from 'components/CustomModal'
import { CheckmarkIcon, InfoIcon, TrashIcon, UserIcon } from 'components/SVGS'
import { customToast } from 'components/ToastCustom'

type Props = {
  contact: ShareVehicleContactType
  idVehicle?: string
  item: VehicleType | null
}

export const SharedContactItem: FC<Props> = ({ contact, idVehicle, item }) => {
  const navigate = useNavigate()
  const {
    icon: { successIconColor, secondaryIconColor, infoIconColor, trashIconColor },
    pressable: { gradientColor: { gradientOne, gradientTwo } }
  } = primaryColor
  const { openDialog, closeModal } = useDisplayModal()
  const {
    deleteContactShareVehicle,
    shareVehicleState: {
      loading,
    },
  } = useShareVehicle()

  const handleDeleteShareVehicle = async (contact: ShareVehicleContactType) => {
    closeModal()

    const res = await deleteContactShareVehicle(contact.id)

    res && customToast.showToast({
      description: `Dejaste de compartir tu vehículo con ${contact.email} exitosamente`, status: 'success',
    })
  }

  const handleDeleteModal = (contact: ShareVehicleContactType) => {
    openDialog({
      content: <CustomModal
        title={`¿Deseas dejar de compartir tu vehículo con ${contact.email}?`}
        primaryButton
        primaryTextButton='Eliminar'
        secondaryButton
        secondaryTextButton='Cancelar'
        closeAcceptPress={() => handleDeleteShareVehicle(contact)}
        closeGoBackPress={closeModal}
      />,
      variant: 'primary'
    })
  }

  const handleEditContact = (contact: ShareVehicleContactType) => {
    navigate('/request-permissions-share-vehicle', {
      state: {
        params: {
          emailInvited: contact.email,
          idInvitation: contact.id,
          idVehicle,
          item,
          isRestricted: contact.isRestricted,
          previousRoute: 'UPDATE'
        }
      }
    })
  }

  return (
    <CardBody borderWidth={1}>
      <HStack p={2} w={'full'} alignItems={'center'} justifyContent={'flex-start'}>
        <HStack alignItems={'center'} justifyContent={'center'}>
          <Box
            justifyContent={'center'}
            alignItems={'center'}
            p={'9px'}
            w={'29px'}
            h={'29px'}
            borderRadius={'8px'}
            bgGradient={`linear(to-br, ${gradientOne}, ${gradientTwo})`}>
            <UserIcon size={8} fill={secondaryIconColor} />
          </Box>
        </HStack>
        <HStack
          w={{ base: '160px', md: 'full' }} overflow={'hidden'} alignItems={'center'} justifyContent={'flex-start'}>
          <VStack w={'full'} alignItems={'center'} justifyContent={'center'}>
            <Text w={'full'} noOfLines={1} variant={'MD'}>{contact.email}</Text>
            <Stack w={'full'} direction={{ base: 'column', md: 'row' }}>
              <Stack direction={'row'}>
                {contact.accepted
                  ? <CheckmarkIcon size={15} fill={successIconColor} />
                  : <InfoIcon size={15} fill={infoIconColor} />
                }
                <Text noOfLines={1} variant={'SM'}>
                  {contact.accepted ? 'Confirmado' : 'Pendiente'}
                </Text>
              </Stack>
              <Text variant={'SM'}>{contact.isRestricted ? 'Permisos sin ubicación' : 'Todos los permisos'}</Text>
            </Stack>
          </VStack>
        </HStack>
        <HStack>
          <IconButton onClick={() => handleDeleteModal(contact)}
            variant={'unstyled'}
            disabled={loading}
            aria-label='icon'
            icon={<TrashIcon size={5} fill={trashIconColor} />}
          />
          <IconButton onClick={() => handleEditContact(contact)}
            variant={'unstyled'}
            disabled={loading}
            aria-label='icon'
            icon={<EditIcon w={4} h={4} />}
          />
        </HStack>
      </HStack>
    </CardBody>
  )
}
